import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerCounterService {
  private isBusyCounter = 0;

  incrementBusyCounter(): void {
    this.isBusyCounter++;
  }

  decrementBusyCounter(): void {
    if (this.isBusyCounter > 0) {
      this.isBusyCounter--;
    }
  }

  isLoading(): boolean {
    return this.isBusyCounter > 0;
  }
}
